module.exports = __webpack_public_path__ + "static/servicios_3-4b86e2e715dd7528a3106c58b101e6bf.jpg";